import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import { AutoComplete } from 'primereact/autocomplete';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import LoadingScreen from '../../components/LoadingScreen';
import { useFormCreateProductSubgroups } from '../../controllers/ProductSubgroups/CreateProductSubgroupsController';
import { useListProductGroupController } from 'src/controllers/ProductGroups/ListProductGroupsController';

interface filteredFieldProps {
	label: string;
	value?: string;
}

const ProductSubgroupForm: React.FC = () => {
	const { getProductSubgroupFormController, handleProductSubgroupFormController } = useFormCreateProductSubgroups();
	const { getProductGroupListController } = useListProductGroupController();

	const [valueGroup, setValueGroup] = useState('');
	const [filteredGroup, setFilteredGroup] = useState<filteredFieldProps[]>([{ label: '', value: '' }]);
	const history = useHistory();

	const [registerFinished, setRegisterFinished] = useState(false);

	useEffect(() => {
		if (getProductSubgroupFormController.ProductSubgroupResponse?.status === 200) {
			setRegisterFinished(true);
		}
		if (
			getProductSubgroupFormController.ProductSubgroupEditedResponse?.status === 200 &&
			!getProductSubgroupFormController.ProductSubgroupResponse
		) {
			setRegisterFinished(false);
			setValueGroup('');
		}
	}, [
		getProductSubgroupFormController.ProductSubgroupResponse,
		getProductSubgroupFormController.ProductSubgroupEditedResponse,
	]);

	const searchGroups = (event: any) => {
		let filteredGroups;
		if (!event.query.trim().length) {
			filteredGroups = [...groups];
		} else {
			filteredGroups = groups.filter(Group => {
				return Group.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}

		setFilteredGroup(filteredGroups);
	};

	const groups = getProductGroupListController.ProductGroupData.map(Group => {
		return { label: Group.DESCRICAO, value: Group.ID };
	});

	return (
		<div style={{ height: '100%' }} className='p-grid p-align-center p-justify-center'>
			<Toast ref={getProductSubgroupFormController.toast} />
			{getProductSubgroupFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			<div className='p-col-12 p-md-8'>
				<div className='card p-fluid'>
					<h5>Subgrupo de Produtos</h5>
					<div className='p-field'>
						<label htmlFor='name'>Nome</label>
						<InputText
							id='name'
							type='text'
							maxLength={150}
							disabled={registerFinished}
							value={getProductSubgroupFormController.formik.values.DESCRICAO}
							onChange={getProductSubgroupFormController.formik.handleChange('DESCRICAO')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getProductSubgroupFormController.formik.touched.DESCRICAO &&
									getProductSubgroupFormController.formik.errors.DESCRICAO,
								'popup-form-inactive': !(
									getProductSubgroupFormController.formik.touched.DESCRICAO &&
									getProductSubgroupFormController.formik.errors.DESCRICAO
								),
							})}>
							{getProductSubgroupFormController.formik.errors.DESCRICAO}
						</div>
					</div>
					<div className='p-field'>
						<label htmlFor='grupo'>Grupo de Produto</label>
						<AutoComplete
							disabled={registerFinished}
							id='grupo'
							value={valueGroup}
							field='label'
							placeholder='Buscar...'
							onChange={e => {
								setValueGroup(e.value);
								getProductSubgroupFormController.formik.setFieldValue(
									'AX_GRUPO',
									filteredGroup.find(Group => {
										return valueGroup.toLowerCase() === Group.label.toLowerCase();
									})?.value || '',
								);
							}}
							onSelect={e => {
								setValueGroup(e.value.label);
								getProductSubgroupFormController.formik.setFieldValue('AX_GRUPO', e.value.value);
							}}
							suggestions={filteredGroup}
							completeMethod={searchGroups}
							dropdown
							dropdownMode='current'
							minLength={2}
							delay={0}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getProductSubgroupFormController.formik.touched.AX_GRUPO &&
									getProductSubgroupFormController.formik.errors.AX_GRUPO,
								'popup-form-inactive': !(
									getProductSubgroupFormController.formik.touched.AX_GRUPO &&
									getProductSubgroupFormController.formik.errors.AX_GRUPO
								),
							})}>
							{getProductSubgroupFormController.formik.errors.AX_GRUPO}
						</div>
					</div>
					<div className='p-fluid p-grid p-justify-between'>
						{getProductSubgroupFormController.ProductSubgroupResponse?.status === 200 &&
						!registerFinished ? (
							<div className='p-col-12 p-md-4'>
								<Button
									type='button'
									label='Salvar Alterações'
									onClick={() => {
										getProductSubgroupFormController.formik.handleSubmit();
									}}
								/>
							</div>
						) : getProductSubgroupFormController.ProductSubgroupResponse?.status === 200 &&
						  registerFinished ? (
							<div className='p-col-12 p-md-6 p-fluid p-grid'>
								<div className='p-col-12 p-md-5'>
									<Button
										type='button'
										label='Editar'
										onClick={() => {
											setRegisterFinished(false);
										}}
									/>
								</div>
								<div className='p-col-12 p-md-5'>
									<Button
										icon='pi pi-plus'
										type='button'
										className='p-button-success'
										label='Cadastrar novo'
										onClick={() => {
											getProductSubgroupFormController.formik.resetForm();
											handleProductSubgroupFormController.setProductSubgroupResponse(null);
											setRegisterFinished(false);
											setValueGroup('');
										}}
									/>
								</div>
							</div>
						) : (
							<div className='p-col-12 p-md-4'>
								<Button
									type='button'
									label='Cadastrar'
									onClick={() => getProductSubgroupFormController.formik.handleSubmit()}
								/>
							</div>
						)}

						<div className='p-col-12 p-md-4'>
							<Button
								type='button'
								className='p-button-secondary'
								label='Voltar para listagem'
								onClick={() => history.goBack()}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProductSubgroupForm;
